
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[pool]/dashboard",
      function () {
        return require("private-next-pages/[pool]/dashboard/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[pool]/dashboard"])
      });
    }
  